export const capitalizeFirstLetter = (value: string | null, locale: string): string => {
  if (!value) return '';

  const first = value[0].toLocaleUpperCase(locale);
  const rest = value.slice(1).toLocaleLowerCase(locale);

  return first + rest;
};
